import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: #fff;
  color: #222;
  border-radius: 10px;
  max-width: 700px;
  width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  padding: 36px 32px 32px 32px;
  position: relative;

  h1, h2, h3 {
    font-family: inherit;
    font-weight: 600;
    margin-top: 1.3em;
    margin-bottom: 0.7em;
    text-align: left;
  }
  h1 {
    font-size: 1.25rem;
  }
  h2 {
    font-size: 1.1rem;
  }
  h3 {
    font-size: 1rem;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 1.7rem;
  color: #888;
  cursor: pointer;
  &:hover {
    color: #4a6cf7;
  }
`;

const DatenschutzModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton aria-label="Schließen" onClick={onClose}>&times;</CloseButton>
        <h1>Datenschutzerklärung</h1>
        <p>Wir legen großen Wert auf den Schutz Ihrer Daten. Um Sie in vollem Umfang über die Verwendung personenbezogener Daten zu informieren, bitten wir Sie, den folgenden Datenschutzhinweis zur Kenntnis zu nehmen.</p>
        <h2>1. Datenschutzerklärung</h2>
        <p>Der Schutz Ihrer persönlichen Daten und Ihrer Privatsphäre ist der <strong>eXplainable AI Solutions GmbH</strong> ("eXplainable AI Solutions", "wir", "uns") ein besonderes Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Vorgaben (DSGVO, DSG) und ergreifen geeignete technische sowie organisatorische Maßnahmen zum Schutz Ihrer Daten.</p>
        <h2>2. Verantwortlicher</h2>
        <p><strong>eXplainable AI Solutions GmbH</strong><br/>
        Johann Nepomuk Berger-Straße 7/RH47<br/>
        7210 Mattersburg, Österreich<br/>
        <a href="https://companion.at" target="_blank" rel="noopener noreferrer">www.companion.at</a><br/>
        E-Mail: <a href="mailto:office@companion.at">office@companion.at</a></p>
        <h2>3. Verarbeitung Ihrer personenbezogenen Daten</h2>
        <p>Wir verarbeiten personenbezogene Daten von:</p>
        <ul>
          <li>Gästen unserer Website</li>
          <li>Kontaktaufnahmen und Kommunikation</li>
          <li>Geschäftspartnern und Kunden</li>
          <li>Bewerbern</li>
          <li>Abonnenten unseres Newsletters</li>
          <li>Nutzern unserer Social Media Kanäle</li>
        </ul>
        <h2>4. Verwendung von Cookies</h2>
        <p>Unsere Website verwendet nur technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind. Diese Cookies speichern keine personenbezogenen Daten und dienen ausschließlich der Funktionalität der Website. Sie können Cookies über Ihre Browsereinstellungen deaktivieren, wodurch jedoch die Funktionalität der Website eingeschränkt werden kann.</p>
        <h2>5. Verwendung von Analyse-Tools</h2>
        <p>Auf unserer Website werden keine Webanalyse- oder Tracking-Tools (wie z.B. Google Analytics) eingesetzt.</p>
        <h2>6. Speicherdauer</h2>
        <p>Wir speichern personenbezogene Daten nur so lange, wie sie zur Erfüllung der oben genannten Zwecke notwendig sind oder wie gesetzlich vorgeschrieben. Bei Widerruf Ihrer Einwilligung oder Ablauf gesetzlicher Aufbewahrungsfristen löschen wir Ihre Daten.</p>
        <h2>7. Schutz Ihrer Daten</h2>
        <p>Wir setzen angemessene technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre personenbezogenen Daten vor Verlust, Missbrauch und unbefugtem Zugriff zu schützen.</p>
        <h2>8. Übermittlung Ihrer personenbezogenen Daten</h2>
        <p>Wir übermitteln Ihre personenbezogenen Daten nur an Dritte, wenn dies gesetzlich erlaubt ist oder Sie eingewilligt haben. Eine Übermittlung in Drittstaaten erfolgt nur unter Wahrung eines angemessenen Datenschutzniveaus.</p>
        <h2>9. Ihre Betroffenenrechte</h2>
        <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung sowie auf Datenübertragbarkeit Ihrer personenbezogenen Daten. Sie können der Verarbeitung Ihrer Daten widersprechen oder eine erteilte Einwilligung widerrufen. Beschwerden richten Sie bitte an die österreichische Datenschutzbehörde:</p>
        <p>
          Österreichische Datenschutzbehörde<br/>
          Barichgasse 40-42, 1030 Wien<br/>
          E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a>
        </p>
        <h2>10. Kontaktdaten</h2>
        <p>Für Fragen zur Verarbeitung Ihrer personenbezogenen Daten oder zur Wahrnehmung Ihrer Rechte kontaktieren Sie uns bitte:</p>
        <p>
          eXplainable AI Solutions GmbH<br/>
          Johann Nepomuk Berger-Straße 7/RH47<br/>
          7210 Mattersburg, Österreich<br/>
          E-Mail: <a href="mailto:office@companion.at">office@companion.at</a>
        </p>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DatenschutzModal;
